import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { TipoDocumento } from '../../models/tipo-documento/tipo-documento';

@Injectable({
  providedIn: 'root',
})
export class TiposDocumentoService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.TIPOS_DOCUMENTO}`;
  constructor(private http: HttpClient) {}

  getTiposDocumento(): Observable<TipoDocumento[]> {
    return this.http.get<TipoDocumento[]>(this.apiUrl);
  }
}
